/**
 * Product gallery — Figma 145:1697 (main stage + thumbnail row).
 */
(function () {
  function init(gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-gearby-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gearby-gallery-thumb]'));
    if (!slides.length) return;

    function setActive(mediaId) {
      const id = String(mediaId);
      slides.forEach((slide) => {
        const match = slide.getAttribute('data-media-id') === id;
        slide.hidden = !match;
        slide.classList.toggle('is-active', match);
      });
      thumbs.forEach((thumb) => {
        const match = thumb.getAttribute('data-media-id') === id;
        thumb.classList.toggle('is-active', match);
        thumb.setAttribute('aria-selected', match ? 'true' : 'false');
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setActive(thumb.getAttribute('data-media-id'));
      });
    });

    const variantSelect = gallery.closest('.gearby-product-page')?.querySelector('[name="id"]');
    if (variantSelect) {
      const syncVariantMedia = () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const mediaId = option?.getAttribute('data-featured-media-id');
        if (mediaId && slides.some((s) => s.getAttribute('data-media-id') === mediaId)) {
          setActive(mediaId);
        }
      };
      variantSelect.addEventListener('change', syncVariantMedia);
    }

    const initial =
      thumbs.find((t) => t.classList.contains('is-active'))?.getAttribute('data-media-id') ||
      slides[0].getAttribute('data-media-id');
    if (initial) setActive(initial);
  }

  document.querySelectorAll('[data-gearby-product-gallery]').forEach(init);
})();
